import { FunctionComponent } from 'react';

import { Button, Header } from '@kanda-libs/ks-design-library';

interface OmniSignDocsModalHeaderProps {
  onClick: () => unknown;
}

const OmniSignDocumentsMobileModalHeader: FunctionComponent<
  OmniSignDocsModalHeaderProps
> = ({ onClick }) => (
  <Header.Base
    className="text-20-24-em text-neutral-900"
    options={[
      <Button.Icon
        key="close"
        id="sign-contract-close"
        onClick={onClick}
        icon="close"
      />,
    ]}
  >
    <>Sign contract</>
  </Header.Base>
);

export default OmniSignDocumentsMobileModalHeader;
